/** @format */
import angular from 'angular';
import searchFilterTpl from './searchFilterResponsibilityInfos.tpl.html';

export const searchFilterResponsibilityInfosModule = 'sis-components.search.searchFilterResponsibilityInfos';

angular.module(searchFilterResponsibilityInfosModule, []).component('searchFilterResponsibilityInfos', {
    bindings: {
        employeeService: '<',
        filterName: '<',
        getSelectionNames: '&',
        helpText: '<',
        popoverIsOpen: '<',
        submitFilter: '&',
        toggleValueCb: '&',
    },
    template: searchFilterTpl,
    controllerAs: 'ctrl',
    controller: [
        '$scope',
        function ($scope) {
            const ctrl = this;

            // Invoke callback methods that take arguments in a way that allows to keep the template file unchanged
            // (that used to call controller methods directly when UI Bootstrap was used)
            ctrl.toggleValue = (value, form, event) => ctrl.toggleValueCb()(value, form, event);

            $scope.$watch('ctrl.popoverIsOpen', newVal => {
                if (!newVal) {
                    // Reset form when popover closes
                    $scope.filterSelectorForm.$setPristine();
                }
            });
        },
    ],
});
